import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable, tap, throwError } from 'rxjs';
import {
  CreateDepositParams,
  DeleteDepositByIdResponse,
  GetDepositByIdResponse,
  GetDepositRequestParams,
  GetDepositResponse,
  UpdateDepositRequestParams,
} from '../../pages/deposits/deposits.interface';
import { environment } from '../../../environments/environment';
import { toQueryString } from '../../shared/helpers/helpers';

@Injectable({
  providedIn: 'root',
})
export class DepositsService {
  private apiUrl = environment.api + '/deposits';

  constructor(private http: HttpClient) {}

  private handleResponse<T>(response: T & { code: number; message?: string }): T {
    if (response.code !== 0) {
      throw new Error(response.message);
    }
    return response;
  }

  private handleError(error: any): Observable<never> {
    console.error('API Error:', error);
    return throwError(() => new Error(error.error?.message || 'Error'));
  }

  getDepositService(requestParams: GetDepositRequestParams): Observable<GetDepositResponse> {
    const url = this.apiUrl + '?' + toQueryString(requestParams);
    return this.http.get<GetDepositResponse>(url).pipe(
      tap((response) => this.handleResponse(response)), // ✅ Pakai arrow function
      catchError((error) => this.handleError(error)) // ✅ Pakai arrow function
    );
  }

  getDepositById(id: string): Observable<GetDepositByIdResponse> {
    return this.http.get<GetDepositByIdResponse>(`${this.apiUrl}/${id}`).pipe(
      tap((response) => this.handleResponse(response)),
      catchError((error) => this.handleError(error))
    );
  }

  deleteDepositById(id: string): Observable<DeleteDepositByIdResponse> {
    return this.http.delete<DeleteDepositByIdResponse>(`${this.apiUrl}/${id}`).pipe(
      tap((response) => this.handleResponse(response)),
      catchError((error) => this.handleError(error))
    );
  }

  createDeposit(depositData: CreateDepositParams): Observable<GetDepositByIdResponse> {
    const formData = new FormData();

    // Tambahkan semua field yang diperlukan
    formData.append('amount', depositData.amount.toString());
    formData.append('type', '2'); // Deposit
    formData.append('status', '3'); // status inquiry

    // Tambahkan file
    if (depositData.file) {
      formData.append('file', depositData.file);
    }

    console.log(formData);
    return this.http.post<GetDepositByIdResponse>(this.apiUrl, formData).pipe(
      tap((response) => this.handleResponse(response)),
      catchError((error) => this.handleError(error))
    );
  }

  updateDeposit(id: string, depositData: UpdateDepositRequestParams): Observable<GetDepositByIdResponse> {
    return this.http.put<GetDepositByIdResponse>(`${this.apiUrl}/${id}`, depositData).pipe(
      tap((response) => this.handleResponse(response)),
      catchError((error) => this.handleError(error))
    );
  }
}
